import { mutationOptions } from '../../common/utils';
import { ADDRESS_QUERY_KEYS } from './keys';
import { addressAPIClient } from '../addressAPIClient';
import type { NormalizeAddressRequest } from './types';

export const ADDRESS_QUERIES = {
  normalizeAddress: () =>
    mutationOptions({
      mutationFn: (payload: NormalizeAddressRequest) => addressAPIClient.normalizeAddress(payload),
      mutationKey: ADDRESS_QUERY_KEYS.normalize(),
    }),
};
